/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRateIndexControl.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/rate-index-control";

export class AutogenModelRateIndexControl<RowType extends ModelRow> extends Endpoint<RowType, RowRateIndexControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowRateIndexControl extends ModelRow<RowRateIndexControlFields> {
	constructor(values?: Partial<RowRateIndexControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowRateIndexControlFields {
	allow_bid_process: string;
	bid_rates_currentdate: string;
	billed_rate_type: string;
	company_id: string;
	contract_rate_type: string;
	customer_id: string;
	dashboard_url: string;
	fetch_once_daily: string;
	generate_rate: string;
	integration_id: string;
	internal_rate_type: string;
	miles_per_gallon: number;
	number_of_reports: number;
	password: string;
	search_range: string;
	service_timeout_duration: number;
	spot_rate_type: string;
	token: string;
	token_expiration_date: Date;
	trailer_type: string;
	use_market_rate_fsc: string;
	user_name: string;
	vendor: string;
	webservice_address: string;
}

